import { ReactNode } from "react"
import { ThemeProvider as ThemeProviderSC } from "styled-components"
import { RMWCProvider } from "@rmwc/provider"
import type { Theme } from "./theme.types"
import { CSSProperties } from "../styles/CSSProperties"
import { setupChart } from "../Charts/ChartGlobals"
import { AddToDocumentHead } from "../DocumentHead"

interface Props {
  children: ReactNode
  theme: Theme
}

export const ThemeProvider: React.FC<Props> = ({ children, theme }: Props) => {
  setupChart(theme)
  return (
    <ThemeProviderSC theme={theme}>
      <RMWCProvider
        typography={{
          defaultTag: `div`,
        }}
        tooltip={{
          showArrow: true,
        }}
      >
        <CSSProperties theme={theme} />
        <AddToDocumentHead>
          <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
        </AddToDocumentHead>
        {children}
      </RMWCProvider>
    </ThemeProviderSC>
  )
}
